import { KycStatus } from './cross-sell-data.model';

export function getKycStatus(isKycVerified: boolean, isAuthenticated: boolean): KycStatus {
    if (!isAuthenticated) {
        return KycStatus.Default;
    }

    if (isKycVerified) {
        return KycStatus.Verified;
    }

    return KycStatus.NonVerified;
}
